<template>
  <div class="container">
    <StockDataSetTab :isSelectPrint="isSelectPrint" @click="click" />
    <div v-if="isSelectPrint">
      <StockDataSetPrintNumTable @setMessage="setMessage" @setCsvNumber="setCsvNumber" />
      <StockDataSetPrintCsvCheck @getCsvData="getCsvData" @isModal="isModal" :csvDetailList="csvDetailList" :modalFlag="modalFlag"/>
    </div>
    <div v-else>
      <StockDataSetInventoryNumTable @setMessage="setMessage" @setInvNumber="setInvNumber" />
      <StockDataSetInventoryCsvCheck @getInvData="getInvData" @isModal="isModal" :inventoryDetailList="inventoryDetailList" :modalFlag="modalFlag" />
      <InventoryTargetFileErrorDetail :showErrorModal="showErrorModal" :inventoryFileErrorList="inventoryFileErrorList" @closeModal="closeModal"/>
    </div>
    <!-- 処理中アイコン -->
    <Loading v-show="isLoading"></Loading>
  </div>
</template>

<script>
import StockDataSetTab from '@/components/pages/StockDataSetTab'
import StockDataSetPrintNumTable from '@/components/pages/StockDataSetPrintNumTable'
import StockDataSetInventoryNumTable from '@/components/pages/StockDataSetInventoryNumTable'
import StockDataSetPrintCsvCheck from '@/components/pages/StockDataSetPrintCsvCheck'
import StockDataSetInventoryCsvCheck from '@/components/pages/StockDataSetInventoryCsvCheck'
import InventoryTargetFileErrorDetail from '@/components/pages/InvetoryTargetFileErrorDetail'
import Loading from '@/components/atoms/Loading'

export default {
  name: 'stock-data-set',
  showErrorModal: Boolean,
  data () {
    return {
      screenTitle: '[マスタ設定] CSV取込設定',
      isSelectPrint: true,
      showErrorModal: false,
      entityCsv: {
        individualCodeNumber: '',
        goodsCodeNumber: '',
        goodsNameNumber: '',
        quantityNumber: '',
        janCodeNumber: '',
        generalItem1Number: '',
        generalItem2Number: '',
        installmentTimeNumber: '',
        headerExist: ''
      },
      entityInv: {
        sectionCodeNumber: '',
        individualCodeNumber: '',
        goodsCodeNumber: '',
        goodsNameNumber: '',
        quantityNumber: '',
        janCodeNumber: '',
        headerExist: ''
      },
      inventoryDetailList: [],
      inventoryFileErrorList: [],
      csvDetailList: [],
      modalFlag: false,
      isLoading: false
    }
  },

  mounted () {
    this.$emit('setScreenTitle', this.screenTitle)
  },

  methods: {
    click (flag) {
      this.isSelectPrint = flag
    },
    setMessage (message, errorFlag) {
      this.$emit('setMessage', message, errorFlag)
    },
    isModal (value) {
      this.modalFlag = value
      if (!value) {
        this.inventoryDetailList = []
        this.csvDetailList = []
      }
    },
    /**
     * メッセージに表示するテキストの設定
     */
    setCsvNumber (entityCsv) {
      this.entityCsv.individualCodeNumber = entityCsv.individualCodeNumber
      this.entityCsv.goodsCodeNumber = entityCsv.goodsCodeNumber
      this.entityCsv.goodsNameNumber = entityCsv.goodsNameNumber
      this.entityCsv.quantityNumber = entityCsv.quantityNumber
      this.entityCsv.janCodeNumber = entityCsv.janCodeNumber
      this.entityCsv.generalItem1Number = entityCsv.generalItem1Number
      this.entityCsv.generalItem2Number = entityCsv.generalItem2Number
      this.entityCsv.installmentTimeNumber = entityCsv.installmentTimeNumber
      this.entityCsv.headerExist = entityCsv.headerExist
    },
    setInvNumber (entityInv) {
      this.entityInv.sectionCodeNumber = entityInv.sectionCodeNumber
      this.entityInv.individualCodeNumber = entityInv.individualCodeNumber
      this.entityInv.goodsCodeNumber = entityInv.goodsCodeNumber
      this.entityInv.goodsNameNumber = entityInv.goodsNameNumber
      this.entityInv.quantityNumber = entityInv.quantityNumber
      this.entityInv.janCodeNumber = entityInv.janCodeNumber
      this.entityInv.headerExist = entityInv.headerExist
    },
    async getInvData (file) {
      try {
        // 処理中アイコン表示
        this.isLoading = true
        await this.readFile(file)
          .then(str => this.sendInvData(str))
      } catch (ex) {
        throw ex
      } finally {
        // 処理中アイコン非表示
        this.isLoading = false
      }
    },
    async getCsvData (file) {
      try {
        // 処理中アイコン表示
        this.isLoading = true
        await this.readFile(file)
          .then(str => this.sendCsvData(str))
        // 処理中アイコン非表示
        this.isLoading = false
      } catch (ex) {
        throw ex
      } finally {
        // 処理中アイコン非表示
        this.isLoading = false
      }
    },
    // 選択されたデータファイルの読み込み
    readFile (file) {
      return new Promise((resolve, reject) => {
        var reader = new FileReader()
        reader.readAsArrayBuffer(file)
        // 読み込みが完了したら中身を取り出す
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    },
    // 棚卸ファイル取込対象CSVチェックAPI呼び出し
    async sendInvData (str) {
      this.$emit('setMessage', null, false)
      var base64str = btoa(
        new Uint8Array(str).reduce((data, byte) => data + String.fromCharCode(byte), '')
      )
      console.log(base64str)
      await this.axios.post('/api/csv/check', {
        binaryData: base64str,
        sectionCodeNumber: this.entityInv.sectionCodeNumber,
        individualCodeNumber: this.entityInv.individualCodeNumber,
        goodsCodeNumber: this.entityInv.goodsCodeNumber,
        goodsNameNumber: this.entityInv.goodsNameNumber,
        quantityNumber: this.entityInv.quantityNumber,
        janCodeNumber: this.entityInv.janCodeNumber,
        headerExist: this.entityInv.headerExist
      }, {
        headers: {
          'Authorization': this.$session.get('accessToken')
        }
      }).then((response) => {
        this.inventoryFileErrorList = response.data.errorList
        if (this.inventoryFileErrorList !== null) {
          console.log(response.data.errorList)
          this.showErrorModal = true
        } else {
          this.inventoryDetailList = response.data.resultList
          console.log(response.data.resultList)
          this.modalFlag = true
        }
      })
    },
    // 印刷元CSVチェックAPI呼び出し
    async sendCsvData (str) {
      this.$emit('setMessage', null, false)

      var base64str = btoa(
        new Uint8Array(str).reduce((data, byte) => data + String.fromCharCode(byte), '')
      )
      console.log(base64str)
      await this.axios.post('/api/csv/print/check', {
        binaryData: base64str,
        individualCodeNumber: this.entityCsv.individualCodeNumber,
        goodsCodeNumber: this.entityCsv.goodsCodeNumber,
        goodsNameNumber: this.entityCsv.goodsNameNumber,
        quantityNumber: this.entityCsv.quantityNumber,
        janCodeNumber: this.entityCsv.janCodeNumber,
        generalItem1Number: this.entityCsv.generalItem1Number,
        headerExist: this.entityCsv.headerExist
      }, {
        headers: {
          'Authorization': this.$session.get('accessToken')
        }
      }).then((response) => {
        this.csvDetailList = response.data.resultList
        console.log(response.data.resultList)
        this.modalFlag = true
      })
    },
    closeModal () {
      this.showErrorModal = false
    }
  },
  computed: {
    getModalFlg () {
      return this.showErrorModal
    }
  },
  components: {
    StockDataSetTab,
    StockDataSetPrintNumTable,
    StockDataSetInventoryNumTable,
    StockDataSetPrintCsvCheck,
    StockDataSetInventoryCsvCheck,
    InventoryTargetFileErrorDetail,
    Loading
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/pages/StockDataSet.vue